import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, DatePicker, Textarea, PaperClip, Select } from 'components';
import { CorporatePaymentService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import moment from 'moment';

interface Props {
	title?: string;
	onClose?: any;
	quotes?: any;
	payment_methods?: any;
}

class CreateCorporatePayment extends React.Component<Props> {

	state = {
		form: {
			payment_method_id: '',
			comments: '',
			photo: ''
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		await CorporatePaymentService.admin.save({
			quote_ids: JSON.stringify(this.props.quotes?.map((i: any) => i.id)),
			...this.state.form,
			hasFile: true,
			// @ts-ignore,
			photo: this.state.form.photo?.value || '',
			amount: this.props.quotes?.map((i: any) => i.price).reduce((a: number,b: number) => a + b,0)
		});
		this.props.onClose(true);
		Globals.showSuccess("Se ha registrado el pago de las citas");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="create-corporate-payments">
				<div className="container-data">
					<p><strong>Clientes:</strong> { this.props.quotes?.map((i: any) => i.user?.full_name).join(', ') }</p>
					<p><strong>Cantidad de ordenes a cancelar:</strong> { this.props.quotes?.length || 0 }</p>
					<p><strong>Monto a pagar:</strong> { Globals.formatMiles(this.props.quotes?.map((i: any) => i.price).reduce((a: number,b: number) => a + b,0)) }</p>

					<Select
						placeholder="Forma de pago"
						name="payment_method_id"
						onChange={ (e: any) => this.change(e) }
						value={ this.state.form.payment_method_id }
						options={ this.props.payment_methods.map((item: any) => {
							return {
								value: item.id,
								label: item.name
							}
						}) } />

					<PaperClip
						value={ this.state.form.photo }
						successText={ `Foto Adjuntada` }
						pendingText={ `Imagen del pago` }
						onChange={ (e: any) => {
							this.setState({
								form: {
									...this.state.form,
									photo: e.target
								}
							})
						} } />

					<Textarea
						rows={ 3 }
						placeholder="Observaciones (Opcional)"
						name="comments"
						onChange={ this.change }
	                    value={ this.state.form.comments } />
	            </div>

				<div className="container-buttons">
					<div className="row">
						<div className="col-md-6">
							<button className="btn btn-green" onClick={ (e) => this.submit(e) }>
								Aceptar
							</button>	
						</div>
						<div className="col-md-6">
							<button className="btn btn-red" onClick={ () => this.props.onClose() }>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default CreateCorporatePayment;